import { observable } from "mobx";
import { RootStore } from "./stores";

class BaseStore {
    @observable
    public errors: string[] = [];

    @observable
    public errorType: "success" | "info" | "warning" | "error";

    @observable
    public currentPage: number;

    @observable
    public total: number;

    @observable
    public loading: boolean;

    public readonly rootStore: RootStore;

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;
    }

    handleException(e: any) {
        if (e.status >= 500) {
            this.errorType = "error";
        }

        if (e.status >= 400) {
            this.errorType = "warning";
        }

        this.errors = e.responseJSON.errors;
    }

    initAPIRequestUIStatuses(isLoadingNeeded = false) {
        if (isLoadingNeeded) {
            this.loading = true;
        }
        this.errors = [];
        this.errorType = "success";
    }
}

export { BaseStore };
